module.exports = __webpack_public_path__ + "UX8.png?a1f95877b0422e1b63326be190841e72";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX8.png
// module id = 106
// module chunks = 0